import { environment as env } from '../environments/environment';
import {IGenericKeyValue} from "./storage/interfaces/generic.interface";

export const CONSTANTS = {
    ROUTES: {
        LOGIN: 'login',
        HOME: 'home',
        ALERTS_VIEW: 'alerts',
        MISSION: 'mission',
        MISSION_SELECTION: 'mission-selection',
        MISSION_CONFIG: 'mission-config',
        MISSION_CONFIG_MENU: 'menu',
        MISSION_INFO: 'info',
        MATERIAL_CONFIG: 'material',
        PRODUCT_CONFIG: 'product',
        TEAM_CONFIG: 'team',
        SUPPORT_CONFIG: 'support',
        CONTAINERS: 'containers',
        TEAMS: 'teams',
        NEW_MISSION: 'mission-create',
        PARTICIPANTS_CONFIG: 'attendees'

    },
    AUTH: {
        LOGIN_URL: `https://${ env.aws.oauth.domain }/login?` +
                   `redirect_uri=${ env.aws.oauth.redirectSignIn }` +
                   `&response_type=${ env.aws.oauth.responseType }` +
                   `&client_id=${ env.aws.amplify.aws_user_pools_web_client_id }`
    },
    STORAGE: {
        MARKET: 'market',
        STATUS_FILTERS: 'status-filters'
    },
    ALERTS: {
        MAX_DISPLAYED: 3,
        TIMEOUT: 10000
    },
    REGIONS: {
        LATAM: "LATAM",
        AMERICAS: "NA",
        EUROPE_MIDDLEEAST: "EMEA",
        ASIA: "APAC",
    },
    MISSION: {
        CONFIG_STATUS: {
            NOT_STARTED: 1,
            IN_PROGRESS: 2,
            COMPLETED: 3,
            BLOCKED: 4,
            CONFIGURATION: 10,
            READY_FOR_CHECKING: 20,
            INJECTION_COMPLETED: 100,
            MISSION_COMPLETED: 110
        }
    },
    UNITS: {
        WEIGHT: "KG",
        TON: "TO",
        VOLUME: "L",
        VOLUME_FLOWRATE: "LH",
        PPM: "PPM",
        PRESSURE: "BARG",
        CUBIC_FLOWRATE: "M3H"
    },
    TEAM: {
        MISSION_LEADER: {
            YES: 1,
            NO: 0
        },
        ROLES: {
            TECHNICIAN: "TECHNICIAN",
            REMOTE_SUPERVISION: "REMOTE SUPERVISION",
            RUN_ITEAM: "RUN ITEAM",
            DATA: "DATA"
        },
        GROUPS: {
          RUN_ITEAM: "Run Iteam"
        }
    },
    LOGOS: {
        SAMAT: "samat.svg",
        SUDOTRANS: "sudotrans.svg"
    },
    TELEMETRY_SUPPLIER: {
        SENSILE: "SENSILE",
        WELLAWARE: "WELLAWARE",
        ARKEMA: "ARKEMA",
        NO_TELEMETRY: "NO TELEMETRY"
    },
    EQUIPMENTS: {
        NO_GATEWAY: "NO_GATEWAY",
        NO_PUMP: "NO_PUMP",
        NO_FLOWMETER: "NO_FLOWMETER",
        NO_ANALYZER: "NO_ANALYZER"
    },
    DATE: {
        SECONDS_IN_A_DAY: 60 * 60 * 24
    }
};


export const PRODUCTS_LIST: IGenericKeyValue[] = [
    {key: '1', value: 'DMDS'},
    {key: '2', value: 'DMDS-E2'}
];

export const VALIDATOR_MIN_DMDS_QTY = 0.05;
export const VALIDATOR_STEP_DMDS_QTY = 0.05;
export const VALIDATOR_MAX_DMDS_QTY = 999999;

export const DMDS_QUANTITY_UNIT_LIST: IGenericKeyValue[] = [
    {key: 'GAL', value: 'gal'},
    {key: 'L', value: 'L'},
    {key: 'PO', value: 'lbs'},
    {key: 'TO', value: 'MT'},
];

export const VALIDATOR_MAX_REACTOR = 5;
export const VALIDATOR_MIN_REACTOR = 1;

export const CATALYST_WEIGHT_UNIT_LIST: IGenericKeyValue[] = [
    {key: 'TO', value: 'MT'},
    {key: 'PO', value: 'lbs'},
];

export const PRODUCT_FAMILY = {
    SULFUR_PRODUCTS: 1,
    AMINO: 2
};

export const VALIDATOR_MIN_CATALYST_WEIGHT = 0.05;
export const VALIDATOR_MAX_CATALYST_WEIGHT = 1000000;
